import { render, staticRenderFns } from "./subject-list.vue?vue&type=template&id=031ec808&scoped=true&"
import script from "./subject-list.vue?vue&type=script&lang=js&"
export * from "./subject-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ec808",
  null
  
)

export default component.exports